import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "ml-2 mt-2" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Add Contract")
const _hoisted_4 = { class: "row ml-2" }
const _hoisted_5 = { class: "row" }

import { ref } from "vue";
import {
  SubscriptionType,
  SubscriptionTypeStatus,
} from "@/models/SubscriptionType";
import { Protocol } from "@/models/Protocol";
import Moralis from "moralis";
import EditContract from "@/components/EditContract.vue";
import { Contract } from "@/models/Contract";

import { fetchProtocol, protocolUpdate } from "@/composables/getProtocolByID";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
  protocolID: { type: String, required: true },
},
  async setup(__props) {

let __temp: any, __restore: any

const props = __props


const selectedProtocol = ref<Protocol>(new Protocol());
selectedProtocol.value = (
  ([__temp,__restore] = _withAsyncContext(() => fetchProtocol(props.protocolID))),
  __temp = await __temp,
  __restore(),
  __temp
);

const contracts = ref<Contract[]>([]);
const selectedContract = ref<Contract>();
const showAddContract = ref(false);

const fetchContracts = async (): Promise<Contract[]> => {
  if (selectedProtocol.value) {
    const cons = await selectedProtocol.value.contracts();
    contracts.value.length = 0;
    contracts.value.push(...cons);
  } else {
    contracts.value.length = 0;
  }
  return contracts.value;
};

;(
  ([__temp,__restore] = _withAsyncContext(() => fetchContracts())),
  await __temp,
  __restore()
);

const startAddContract = () => {
  selectedContract.value = new Contract();
  showAddContract.value = true;
  scrollToContract();
};
const editContract = (contract: Contract) => {
  selectedContract.value = contract;
  showAddContract.value = true;
  scrollToContract();
};
const contractSaved = () => {
  showAddContract.value = false;
  fetchContracts();
};

const editedContract = ref(null);
const scrollToContract = (): void => {
  const el: any = editedContract.value;
  if (el) {
    var top = el.offsetTop;
    window.scrollTo(0, top);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_card_title = _resolveComponent("va-card-title")!
  const _component_va_chip = _resolveComponent("va-chip")!
  const _component_va_card_actions = _resolveComponent("va-card-actions")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_va_divider = _resolveComponent("va-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_va_button, {
        onClick: startAddContract,
        icon: "add"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contracts.value, (contract) => {
        return (_openBlock(), _createBlock(_component_va_card, {
          square: "",
          outlined: "",
          class: "flex sm12 md4 lg3",
          key: contract.id
        }, {
          default: _withCtx(() => [
            _createVNode(_component_va_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(contract.name), 1)
              ]),
              _: 2
            }, 1024),
            _createElementVNode("div", null, [
              _createVNode(_component_va_chip, { outline: "" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(contract.chain), 1)
                ]),
                _: 2
              }, 1024),
              _createTextVNode(" " + _toDisplayString(contract.short_address), 1)
            ]),
            _createVNode(_component_va_card_actions, { align: "stretch" }, {
              default: _withCtx(() => [
                _createVNode(_component_va_button, {
                  onClick: ($event: any) => (editContract(contract)),
                  icon: "edit"
                }, null, 8, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (showAddContract.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref_key: "editedContract",
            ref: editedContract,
            class: "pl-3"
          }, [
            _createVNode(_component_va_divider),
            _createVNode(EditContract, {
              onContractSaved: contractSaved,
              onCancel: _cache[0] || (_cache[0] = ($event: any) => (showAddContract.value = false)),
              onUpdated: scrollToContract,
              contract: this.selectedContract,
              protocol: this.selectedProtocol
            }, null, 8, ["contract", "protocol"])
          ], 512))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})